import React from "react";
import { ChatWrapper } from "@features/chat/mobile";

export default function ChatWrap(props: {
	children: JSX.Element[] | JSX.Element;
}) {
	return (
		<>
			{props.children}
			<ChatWrapper />
		</>
	);
}
